import * as moment from 'moment';
import OrganizationDirectSelling from '../../../commonComponents/propTypes/OrganizationDirectSelling';
import { RECURRENCE_INTERVAL_CUSTOM } from '../../../services/dateUtilityFunctions';

const getInitialState = recurrence => {
  const startOfMonth = moment().utc().startOf('month').valueOf();
  const startOfWeek = moment().utc().clone().startOf('isoWeek').valueOf();
  const today = moment().endOf('day').valueOf();
  return {
    startDate:
      recurrence === OrganizationDirectSelling.RECURRENCE.WEEKLY
        ? startOfWeek
        : startOfMonth,
    endDate: today,
    search: '',
    rangeType: RECURRENCE_INTERVAL_CUSTOM,
  };
};

// eslint-disable-next-line import/prefer-default-export
export { getInitialState };
